module.exports = __webpack_public_path__ + "media/recupel3.fe5ac25f.mp4";